class SiteHeader {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;

		this.megaMenuLinks = el.querySelectorAll('.mega-menu-item');
		this.mobileLinks = el.querySelectorAll('.mobile-top-level-link-clickable');
		this.megaMenuBg = document.querySelector('.site-header__megamenu-bg');
		this.mobileMenu = document.querySelector('.site-header__mobile-menu');

		this.updateHeaderHeightVar();
		this.setupEventHandlers();
		this.removeSearchValue();
	}

	setupEventHandlers() {
		const body = document.querySelector('body');
		// mobile menu button handler
		const btnMobileMenu = this.el.querySelector('.site-header__mobile-menu-button');

		if (btnMobileMenu) {
			btnMobileMenu.addEventListener('click', () => {
				document.documentElement.classList.toggle('mobile-menu-active');
				this.adjustMobileMenuHeight();
			});
		}

		// mobile menu handler 
		if (this.mobileLinks) {
			this.mobileLinks.forEach((link) => {
				link.addEventListener('click', (e) => {
					e.preventDefault();
					this.mobileLinks.forEach((closeLink) => {
						if (closeLink !== link) {
							closeLink.classList.remove('active');
						}
					});
					link.classList.toggle('active');
					this.adjustMobileMenuHeight();
				});
			});
		}

		document.addEventListener('click', (e) => {
			const isClickInsideMenu = this.mobileMenu?.contains(e.target);
			const isClickOnButton = btnMobileMenu?.contains(e.target);
	
			if (!isClickInsideMenu && !isClickOnButton) {
				document.documentElement.classList.remove('mobile-menu-active');
				this.mobileLinks.forEach(link => link.classList.remove('active'));
			}
		});

		window.addEventListener('resize', () => {
			this.updateHeaderHeightVar();
			this.adjustMobileMenuHeight();
		});
		window.addEventListener('scroll', () => this.updateHeaderHeightVar());


		// mega menu handler 
		if (this.megaMenuLinks) {
			this.megaMenuLinks.forEach((link) => {
				// open with hover
				link.addEventListener('mouseenter', () => {
					this.megaMenuLinks.forEach((megaMenuLink) => {
						if (megaMenuLink !== link) {
							megaMenuLink.setAttribute('aria-expanded', false);
							megaMenuLink.classList.remove('active');
						}
					});
		
					link.setAttribute('aria-expanded', true);
					link.classList.add('active');
					//body.classList.add('no-scroll');
					this.megaMenuBg.classList.add('active');

					const menuContent = link.nextElementSibling; 
					if (menuContent) {
						const rect = link.getBoundingClientRect();
						 menuContent.style.position = 'fixed';
						 menuContent.style.left = rect.left + 'px';
						 menuContent.style.top = rect.bottom + 'px';
					}
				});
		
				//close 
				link.addEventListener('mouseleave', () => {
					link.setAttribute('aria-expanded', false);
					link.classList.remove('active');
					//body.classList.remove('no-scroll');
					this.megaMenuBg.classList.remove('active');
				});
			});
		}
	}

	adjustMobileMenuHeight() {
		if (!this.mobileMenu) return;
	
		const wrapper = this.mobileMenu.querySelector('.site-header__mobile-menu-wrapper');
		if (!wrapper) return;
	
		const headerOffset = 9 * parseFloat(getComputedStyle(document.documentElement).fontSize); 
	
		const contentHeight = wrapper.scrollHeight + headerOffset; 
		const viewportHeight = window.innerHeight;
	
	
		if (contentHeight > viewportHeight) {
			this.mobileMenu.style.height = (viewportHeight - headerOffset) + 'px';
			this.mobileMenu.classList.add('scrollable');
		} else {
			this.mobileMenu.style.height = (contentHeight - headerOffset) + 'px';
			this.mobileMenu.classList.remove('scrollable');
		}
	}
	

	updateHeaderHeightVar() {
		this.headerHeight = this.el.offsetHeight;
	}

	removeSearchValue() {
		const searchInput = document.getElementById('searchsubmitmobile');
		if (searchInput) {
			searchInput.value = '';
		}
	}
}

export default SiteHeader;
